export default __webpack_public_path__ + "static/media/booking-management.9da2ce0c.svg";